import React, { memo } from 'react';
import { Typography } from 'fronton-react';
import { InfoIcon } from '@fronton/icons-react';
import { InfoBar, StyledUl, captionStyles, titleStyles } from './styles';

export const RezkaDereva = memo(() => {
	return (
		<div data-qa="rezka-dereve">
			<Typography variant="s" size="body_long" className={captionStyles}>
				* Выполняем резку материалов, приобретённых только в данном магазине
			</Typography>
			<InfoBar>
				<InfoIcon type="duotone" size="l" color="success-dark" />
				<div>
					<Typography variant="m" size="body_accent">
						Важно! Обратите внимание на технологические ограничения:
					</Typography>
					<StyledUl>
						<li>
							<Typography variant="s" size="body_long">
								- детали размером менее 25 см не подлежат распилу
							</Typography>
						</li>
						<li>
							<Typography variant="s" size="body_long">
								- при резке дерева возможен только поперечный распил
							</Typography>
						</li>
					</StyledUl>
					<Typography variant="m" size="body_accent" className={titleStyles}>
						Перед тем, как приехать к нам в магазин:
					</Typography>
					<StyledUl>
						<li>
							<Typography variant="s" size="body_long">
								- уточните минимальный размер материала для распила
							</Typography>
						</li>
					</StyledUl>
				</div>
			</InfoBar>
		</div>
	);
});
